<!--
 * @Author: AI Assistant
 * @Date: 2026-01-27
 * @Description: 创作面板收缩/展开切换按钮组件
 * @FilePath: /weryai-web/components/chatCreation/PanelCollapseToggle.vue
-->
<template>
    <button type="button" class="panel-collapse-toggle" :class="{ 'is-collapsed': collapsed }"
        :aria-label="collapsed ? 'Expand panel' : 'Collapse panel'" :aria-expanded="!collapsed" @click="handleToggle">
        <span class="toggle-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="currentColor">
                <path
                    d="M2.18839e-07 4.99354C2.28405e-07 4.7747 0.0625264 4.55586 0.218841 4.39955L3.65777 0.33536C4.00166 -0.0710591 4.59566 -0.102322 4.97081 0.210307C5.37723 0.5542 5.40849 1.1482 5.09587 1.52335L2.15715 4.99354L5.09586 8.46373C5.43976 8.87015 5.37723 9.46415 4.97081 9.77678C4.56439 10.1207 3.9704 10.0581 3.65777 9.65173L0.218841 5.58754C0.0625264 5.43122 2.09273e-07 5.21238 2.18839e-07 4.99354Z"
                    fill="currentColor" />
            </svg>
        </span>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '~/stores/app'

const appStore = useAppStore()

const collapsed = computed(() => appStore.creatorPanelCollapsed)

const handleToggle = () => {
    appStore.toggleCreatorPanelCollapsed()
}
</script>

<style scoped lang="less">
.is-collapsed .toggle-icon {
    transform: rotate(180deg) !important;
}

.panel-collapse-toggle {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 150px;
    padding: 0;
    background: #101012;
    border-left: none;
    border-radius: 0 8px 8px 0;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-top: 1px solid rgba(255, 255, 255, 0.10);
    border-right: 1px solid rgba(255, 255, 255, 0.10);
    border-bottom: 1px solid rgba(255, 255, 255, 0.10);
    background: #101012;

    &:hover {
        background: #0B2000;

        .toggle-icon {
            color: #99F768;
        }
    }

    &:focus-visible {
        outline: 2px solid #99f768;
        outline-offset: 2px;
    }

    .toggle-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        transition: all 0.3s ease;

    }

    .chevron-icon {
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }



    // 收缩状态：使用固定定位，贴靠页面最左侧
    &.is-collapsed {
        position: fixed;
        left: 0; // 左侧工具栏已移除，直接贴左边
        right: auto;
        top: 50%;
        transform: translateY(-50%);
        z-index: 30; // 收起状态保持高层级，确保可点击
        border-radius: 0 8px 8px 0;
        border-left: none;
        background: rgba(115, 167, 83, 0.10);
        border-top-color: rgba(115, 167, 83, 0.20);
        border-right-color: rgba(115, 167, 83, 0.20);
        border-bottom-color: rgba(115, 167, 83, 0.20);

        .chevron-icon {
            transform: rotate(180deg);
        }

        .toggle-icon {
            color: #99F768;
        }
    }
}

// 移动端隐藏
@media (max-width: 1023px) {
    .panel-collapse-toggle {
        display: none;
    }
}
</style>
